import { useCreation } from "ahooks";
import { atom, type Atom, type PrimitiveAtom, useSetAtom } from "jotai";
import { useEffect } from "react";

export type AtomRecord<T extends object> = Required<{
  [K in keyof T]: Atom<T[K]>;
}>;

export function useAtomsFromProps<T extends object>(props: T): AtomRecord<T> {
  const { keys, atoms } = useCreation(() => {
    const keys = Object.keys(props);
    const atoms = keys.reduce<{ [K in keyof T]: PrimitiveAtom<T[K]> }>(
      (acc, _key) => {
        const key = _key as keyof T;
        acc[key] = atom(props[key]);
        return acc;
      },
      {} as { [K in keyof T]: PrimitiveAtom<T[K]> }
    );

    return {
      keys,
      atoms,
    };
  }, []);

  for (const _key of keys) {
    const key = _key as keyof T;
    const setAtom = useSetAtom(atoms[key]);

    useEffect(() => {
      setAtom(props[key]);
    }, [props[key]]);
  }

  return atoms as any;
}
